import './ModalFooter.scss';
import clsx from 'clsx';
import React, { memo, ReactNode } from 'react';

type Props = {
  fullScreen?: boolean;
  narrowFooter?: boolean;
  children: ReactNode;
};

export const ModalFooter = memo(({ fullScreen, narrowFooter, children }: Props) => (
  <div className={clsx({
    'bp-modal-footer': true,
    'bp-modal-footer--full-screen': fullScreen,
    'bp-modal-footer--narrow-footer': narrowFooter,
  })}
  >
    {children}
  </div>
));
